import styled from 'styled-components';

// Cores fixas (preto/branco/cinza) em vez dos tokens do app -- a ficha é
// impressa em papel, não faz sentido herdar o tema escuro da plataforma.
export const Sheet = styled.div`
  display: none;

  @media print {
    display: block;
    padding: 24px;
    color: #111;
    background: #fff;
    font-family: 'Lexend', sans-serif;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 2px solid #111;
  margin-bottom: 20px;
`;

export const GymIdentity = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 8px;
  }

  span {
    font-size: 14px;
    font-weight: 700;
  }
`;

export const DocTitle = styled.div`
  text-align: right;

  h1 {
    font-size: 20px;
    font-weight: 800;
  }

  p {
    font-size: 11px;
    color: #555;
  }
`;

export const StudentInfo = styled.div`
  margin-bottom: 20px;

  h2 {
    font-size: 16px;
    font-weight: 700;
  }

  p {
    font-size: 11px;
    color: #555;
    margin-top: 2px;
  }
`;

export const SplitBlock = styled.section`
  margin-bottom: 24px;
  break-inside: avoid;

  h3 {
    font-size: 14px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 8px;
    padding: 4px 8px;
    background: #eee;
  }
`;

export const ExercisesTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  th,
  td {
    border: 1px solid #ccc;
    padding: 6px 8px;
    text-align: left;
  }

  th {
    background: #f5f5f5;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
`;

export const Footer = styled.footer`
  margin-top: 24px;
  padding-top: 8px;
  border-top: 1px solid #ccc;
  font-size: 10px;
  color: #777;
  text-align: center;
`;
